import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(date))
}

export function formatConfidence(confidence: number) {
  if (confidence >= 0.8) return { label: 'High', class: 'confidence-high' }
  if (confidence >= 0.5) return { label: 'Medium', class: 'confidence-medium' }
  return { label: 'Low', class: 'confidence-low' }
}

export function getSentimentColor(sentiment: string) {
  switch (sentiment) {
    case 'positive': return 'text-green-600 bg-green-50 border-green-200'
    case 'negative': return 'text-red-600 bg-red-50 border-red-200'
    case 'neutral': return 'text-gray-600 bg-gray-50 border-gray-200'
    default: return 'text-gray-600 bg-gray-50 border-gray-200'
  }
}

export function getEntityTypeIcon(type: string) {
  switch (type) {
    case 'email': return '📧'
    case 'phone': return '📱'
    case 'username': return '👤'
    case 'domain': return '🌐'
    case 'location': return '📍'
    case 'post': return '📝'
    case 'device': return '💻'
    case 'passport': return '📄'
    default: return '🔍'
  }
}

export function truncateText(text: string, maxLength: number = 100) {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout
  return (...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}